module.exports = __webpack_public_path__ + "img/IGuru64_ua.cecca004.webp";